<template>
    <h2 class="text_sec" style="text-align: center;">{{ $t('emptyState.hello') }}</h2>
    <div class="row justify-content-center">
        <div class="col-md-8">
    <div class="card_thing_sm mt-4" style="text-align: left;">
        <UploadComponent class="mt-2 mb-2">
            <div class="info_action">
                <span style="font-size: 2.5rem;" class="text_sec"><i class="bi bi-plus-circle"></i></span>
                <div>
                    <span style="font-weight: 600;" class="text_sec">{{ $t('emptyState.addTrack') }}</span><br>
                    <span class="text_sec">{{ $t('emptyState.addTrackSubtitle') }}</span>
                </div>
                <div>
                    <span style="font-size: 1.5rem;" class="text_sec"><i class="bi bi-chevron-right"></i></span>
                </div>
            </div>
        </UploadComponent>

        <div class="context_menu_separator"></div>
        <div class="mt-2 mb-2" style="display: flex; gap: 1rem; align-items: center;">
            <span style="font-size: 2.5rem;" class="text_sec"><i class="bi bi-box-seam"></i></span>
            <div>
                <span style="font-weight: 600;" class="text_sec">{{ $t('emptyState.dragDrop') }}</span><br>
                <span class="text_sec">{{ $t('emptyState.dragDropSubtitle') }}</span>
            </div>
        </div>

        <div class="context_menu_separator"></div>
        <div class="mt-2 mb-2" style="display: flex; gap: 1rem; align-items: center;">
            <span style="font-size: 2.5rem;" class="text_sec"><i class="bi bi-cloud"></i></span>
            <div>
                <span style="font-weight: 600;" class="text_sec">{{ $t('emptyState.switchStorage') }}</span><br>
                <span class="text_sec">{{ $t('emptyState.switchStorageSubtitle') }}</span>
            </div>
        </div>

                <div class="context_menu_separator"></div>
        <div class="mt-2 mb-2 info_action" v-on:click="this.$router.push('/settings?tab=agents')">
            <span style="font-size: 2.5rem;" class="text_sec"><i class="bi bi-cloud-arrow-up"></i></span>
            <div>
                <span style="font-weight: 600;" class="text_sec">{{ $t('emptyState.installAgent') }}</span><br>
                <span class="text_sec">{{ $t('emptyState.installAgentSubtitle') }}</span>
            </div>
                        <div>
                <span style="font-size: 1.5rem;" class="text_sec"><i class="bi bi-chevron-right"></i></span>
            </div>
        </div>

        <div class="context_menu_separator"></div>
        <div class="mt-2 mb-2" style="display: flex; gap: 1rem; align-items: center;">
            <span style="font-size: 2.5rem;" class="text_sec"><i class="bi bi-play-circle"></i></span>
            <div>
                <span style="font-weight: 600;" class="text_sec">{{ $t('emptyState.playTrack') }}</span><br>
                <span class="text_sec">{{ $t('emptyState.playTrackSubtitle') }}</span>
            </div>
        </div>
    </div>
    </div>
    </div>
    <div class="mt-4 text_sec" style="text-align: center;">
    <p>
        {{ communityPrefix }}
        <a href="https://discord.gg/WShxsWqkv4">discord</a>
        {{ communityMiddle }}
        <a href="https://t.me/demopartyapp">telegram</a>.
    </p>

    </div>
</template>

<script>
import UploadComponent from './UploadComponent.vue';

export default {
    name: 'InfoComponent',
    components: { UploadComponent },
    computed: {
        communityPrefix() {
            return this.$t('emptyState.community', { discord: '{discord}', telegram: '{telegram}' }).split('{discord}')[0]
        },
        communityMiddle() {
            const parts = this.$t('emptyState.community', { discord: '{discord}', telegram: '{telegram}' }).split('{discord}')
            return (parts[1] || '').split('{telegram}')[0]
        }
    }
}
</script>

<style>
a {
    color: var(--primary-text-color);
    cursor: pointer;
}

.card_thing_sm {
    padding-block: 0.5rem;
    padding-inline: 1rem;
    background-color: #1E1E1E;
    border: 1px solid rgba(47, 47, 47, 1);
    box-shadow: inset 0 2px 4px 0 #ffffff06;
    border-radius: 0.75rem;
}

.info_action {
    display: flex;
    gap: 1rem;
    align-items: center;
    cursor: pointer;
}
</style>
